interface SectionTitleProps {
  eyebrow: string
  title: string
  description?: string
}

export function SectionTitle({ eyebrow, title, description }: SectionTitleProps) {
  return (
    <header className="section-title reveal">
      <small>{eyebrow}</small>
      <h2>{title}</h2>
      {description ? <p>{description}</p> : null}
    </header>
  )
}
